import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "search-page",
  class SearchPage extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");

      this.paramsToUseFromUrl = new URLSearchParams(window.location.search);

      this.fetchResults();

      this.form.addEventListener("change", this.handleChange.bind(this));

      window.addEventListener("popstate", this.handlePopstate.bind(this));

      this.subscribe(
        WYATT.PubSub.events.updateSearchHistory,
        this.updateHistory.bind(this),
      );

      this.subscribe(
        WYATT.PubSub.events.clearAllFilters,
        this.handleClearAll.bind(this),
      );
    }

    get formData() {
      return new FormData(this.form);
    }

    get formParams() {
      return new URLSearchParams(this.formData);
    }

    get requestParams() {
      const hiddenParams = new URLSearchParams(this.config.hiddenParams);
      const trackingParams = new URLSearchParams(WYATT.searchspring.tracking);
      const { formParams } = this;

      const urlParams = new URLSearchParams(this.paramsToUseFromUrl);
      [...formParams.keys()].forEach((key) => urlParams.delete(key));

      const params = new URLSearchParams([
        ...hiddenParams,
        ...formParams,
        ...urlParams,
        ...trackingParams,
      ]);

      params.set("domain", window.location.href);

      return params;
    }

    get pageUrl() {
      const params = new URLSearchParams(this.formParams);

      params.delete("siteId");

      return `${window.location.pathname}?${params.toString()}`;
    }

    handleChange(event) {
      event.preventDefault();

      this.paramsToUseFromUrl = [];

      this.fetchResults();
    }

    handlePopstate(event) {
      event.preventDefault();

      this.fetchResults();
    }

    handleClearAll() {
      const params = new URLSearchParams(this.requestParams);

      Array.from(params.keys())
        .filter((key) => key.startsWith("filter."))
        .forEach((key) => params.delete(key));

      this.fetchResults(params);
    }

    async fetchResults(params = this.requestParams) {
      this.setAttribute("data-loading", "");
      this.setAttribute("aria-busy", "true");

      const requestUrl = [
        "https://",
        `${params.get("siteId")}.`,
        `${WYATT.config.searchspring.endpoints.search}?`,
        params.toString(),
      ].join("");

      try {
        const response = await fetch(
          requestUrl,
          WYATT.config.searchspring.options.get,
        );

        if (!response.ok) {
          throw new Error(`Search request failed: ${response.status}`);
        }

        const data = await response.json();

        const redirectPath = data.merchandising?.redirect;
        if (typeof redirectPath === "string" && redirectPath.trim() !== "") {
          const path = redirectPath.trim();
          const root = WYATT.routes.root.replace(/\/+$/, "");
          window.location.href = `${root}${path.startsWith("/") ? path : `/${path}`}`;
          return;
        }

        this.handleUpdate(data);
      } catch (error) {
        console.error(error);
      } finally {
        this.removeAttribute("data-loading");
        this.setAttribute("aria-busy", "false");
      }
    }

    handleUpdate(data) {
      this.dataset.ssResponseId = (data && data.responseId) || "";

      this.publish(WYATT.PubSub.events.searchResultsFetched, data);

      this.updateTitle(data);
      this.updateHistory();
    }

    updateTitle(data) {
      if (!this.config.title) {
        return;
      }

      document.title = this.config.title
        .replace("{{ count }}", data.pagination.totalResults)
        .replace("{{ query }}", `"${this.formData.get("q")}"`);
    }

    updateHistory() {
      window.history.pushState({}, "", this.pageUrl);
    }
  },
);
